import { render, staticRenderFns } from "./CartaoInformacoesPrestador.vue?vue&type=template&id=3ac9b0fc&scoped=true"
import script from "./CartaoInformacoesPrestador.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesPrestador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac9b0fc",
  null
  
)

export default component.exports